import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  constructor() { }

  // General environment properties
  get isProduction(): boolean {
    return environment.production;
  }

  get environmentName(): string {
    return environment.environmentName;
  }

  get version(): string {
    return environment.version;
  }

  // API configuration
  get apiUrl(): string {
    return environment.apiUrl;
  }

  get apiTimeout(): number {
    return environment.apiTimeout;
  }

  // Debug and logging
  get enableLogging(): boolean {
    return environment.enableLogging;
  }

  get enableDebugMode(): boolean {
    return environment.enableDebugMode;
  }

  // UI configuration
  get theme(): string {
    return environment.ui.theme;
  }

  get language(): string {
    return environment.ui.language;
  }

  get showDevTools(): boolean {
    return environment.ui.showDevTools;
  }

  // Utility methods
  logEnvironmentInfo(): void {
    if (this.enableLogging) {
      console.log('🌍 Environment Info:', {
        name: this.environmentName,
        production: this.isProduction,
        version: this.version,
        apiUrl: this.apiUrl,
      });
    }
  }

  getFullEnvironment(): any {
    return environment;
  }
}
